<template>
  <div class="ScteContent">
    <!-- PassthroughBlock开关 -->
    <div class="PassthroughBlock" v-if="PassthroughBlock.sctePassthroughBlockFeature&&PassthroughBlock.settingPassthroughBlock">
      <p>{{ $t('lang.sctePassthroughBlock') }}</p>
      <div class="SelectSwitch">
        <div class="switchLoading">
          <span class="pushingIcon" v-show="passthroughLoading">
            <i class="el-icon-loading"></i>
          </span>
          <el-switch
            v-show="!passthroughLoading"
            :disabled="CloneDisabled.Scte||CloneDisabled.disableButton"
            v-model="PassthroughBlock.switch"
            @change="BreakPassthroughBlock"
            active-color="#13ce66"
            inactive-color="#666666"
          >
          </el-switch>
        </div>
      </div>
    </div>
    <!-- scte垫片选择开关 -->
    <div class="BreakUnderplay" v-if="BreakUnderplay.scteUnderPlayFeature">
      <p>{{ $t('lang.scteBreakUnderplay') }}</p>
      <div class="SelectSwitch">
        <public-multiple-select
          v-if="configParams"
          :configParams="configParams"
          :SelectValue="{
            fileId: BreakUnderplayMessage.fileId,
            fileName: BreakUnderplayMessage.fileName,
          }"
          :disabled="scteLoading"
          @MediaLiveSelectChange="fileSeleteChange"
        >
        </public-multiple-select>
        <!-- <public-file-select
          :SelectType="1"
          :SelectValue="{
            fileId: BreakUnderplayMessage.fileId,
            fileName: BreakUnderplayMessage.fileName,
          }"
          :AppendBody="false"
          :disabled="CloneDisabled.Scte"
          @fileSelectChange="pitchOnFile => fileSeleteChange(pitchOnFile)"
        ></public-file-select> -->
        <div class="switchLoading">
          <span class="pushingIcon" v-show="scteLoading">
            <i class="el-icon-loading"></i>
          </span>
          <el-switch
            :disabled="CloneDisabled.Scte||CloneDisabled.disableButton"
            v-show="!scteLoading"
            v-model="BreakUnderplay.switch"
            @change="BreakUnderplayChange"
            active-color="#13ce66"
            inactive-color="#666666"
          >
          </el-switch>
        </div>
      </div>
    </div>
    <!--signalType  -->
    <div class="signalType">
      <p>{{ $t('lang.signalType') }}</p>
      <!-- scte类型选择 -->
      <el-select
        v-model="ScteMessage.conmmandType"
        @change="changeConmmandType"
        :disabled="!ScteMessage.IsBegin"
      >
        <el-option
          v-for="item in signalType"
          :key="item.conmmandType"
          :label="item.title"
          :value="item.conmmandType"
        >
        </el-option>
      </el-select>
    </div>
    <div class="ScteSelete">
      <el-select
        v-if="!ScteMessage.scteType && ScteMessage.conmmandType != 99"
        v-model="ScteMessage.type"
        @change="setScteBehavior"
        :disabled='!ScteMessage.IsBegin'
      >
        <el-option
          v-for="(item, index) in ScteType"
          :key="index"
          :label="item.title"
          :value="item.type"
        >
        </el-option>
      </el-select>
      <!-- Time signal = 4 -->
      <el-select
        v-model="ScteMessage.signalType"
        @change="setScteBehavior"
        v-if="ScteMessage.scteType == 2"
      >
        <el-option
          v-for="item in conmmandTypeList"
          :key="item.type"
          :label="item.name"
          :value="item.type"
        >
        </el-option>
      </el-select>
      <!-- LBand选择 -->
      <el-select
        v-model="ScteMessage.signalType"
        @change="setScteBehavior"
        v-if="ScteMessage.conmmandType == 99"
        :disabled='!ScteMessage.IsBegin'
      >
        <el-option
          v-for="item in LBandList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <!-- 按钮 -->
    <div class="ScteButton">
      <!-- 自定义时间框 -->
      <div class="CustomTime" v-if="ScteMessage.type == 9&&!ScteMessage.scteType&&ScteMessage.conmmandType != 99">
        <el-input
          v-model="ScteMessage.time"
          @input="onTimeInput"
          :disabled="!ScteMessage.IsBegin"
        ></el-input>
        <span>seconds</span>
      </div>
      <div>
        <!-- 开始按钮 -->
        <el-button
          :disabled="CloneDisabled.Scte||CloneDisabled.disableButton"
          v-if="ScteMessage.IsBegin || ScteMessage.scteType == 2"
          class="saveBtn"
          :loading="saveLoading"
          type="success"
          v-repeat-click="{ delay: 200, event: () => { ScteCreateStart('开始') } }"
          >{{
            ScteMessage.scteType == 2 ? $t('lang.fire') : $t('lang.start')
          }}</el-button>
        <div v-else-if="!ScteMessage.IsBegin && ScteMessage.conmmandType == 99">
          <el-button
          :disabled="CloneDisabled.Scte||CloneDisabled.disableButton"
          class="ScteStop button"
          :loading="saveLoading"
          type="danger"
          v-repeat-click="{ delay: 200, event: () => { ScteCreateStart('结束') }}"
        >
          {{ $t('lang.Stop') }} ({{ ScteInterval.time }}s)
        </el-button>
        </div>
        <div v-else>
          <!-- 结束按钮 -->
          <el-button
            :disabled="CloneDisabled.Scte||CloneDisabled.disableButton"
            v-if="ScteMessage.scteType == 1|| ScteMessage.conmmandType == 99"
            class="ScteStop button"
            :loading="saveLoading"
            type="danger"
            v-repeat-click="{ delay: 200, event: () => { ScteCreateStart('结束') }}"
          >
            {{ $t('lang.Stop') }} ({{ ScteInterval.time }}s)
          </el-button>
          <div class="autoScteStop button" v-else>
            {{ $t('lang.autoStop') }} {{ ScteInterval.time }}s
          </div>
        </div>

        <!-- <div class="ScteStart button" v-repeat-click="{ delay: 200, event: ScteCreateStart }">
          {{ $t('lang.start') }}
        </div> -->
      </div>
      <!-- <div v-else>
        <div class="ScteStop button">
          {{ $t('lang.autoStop') }} {{ ScteInterval.time }}s
        </div>
      </div> -->
    </div>
    <!-- scte记录列表展示 -->
    <div class="ScteHistoryList">
      <div class="ScteHistory" v-for="item in ScteHistoryList" :key="item.id">
        <div class="left">
          <div class="name">{{ item.nickName }}</div>
          <div class="time">
            {{ displayTime(item.startTime) }}
          </div>
        </div>
        <div class="right">
          {{ calculateInterval(item.duration) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import PublicMultipleSelect from '@/components/select/PublicMultipleSelect.vue'
import { AutoScteTime } from '@/assets/js/common/ParamConfig.js'

export default {
  props: {
    fixedDevice: {
      // 选中图片的信息及位置
      default: null,
      type: Object
    }
  },
  components: {
    PublicMultipleSelect
  },
  data () {
    return {
      scteLoading: false,
      // 未设置underplay的scte的文件 开关
      BreakUnderplay: {
        switch: false, // 是否打开
        forbidden: true, // 是否选择文件true是没有选择
        scteUnderPlayFeature: true // 是否展示功能
      },
      // BreakUnderplay信息
      BreakUnderplayMessage: {
        programId: '',
        fileId: '',
        fileName: '',
        url: '',
        turnOn: 0,
        type: 1
      },
      // signal Type的placeholder
      initPlaceholder: '',
      typePlaceholder: '',
      // conmmandType==4时select列表
      conmmandTypeList: [],
      // signalType类型
      signalType: [],
      // scte的类型选择项
      ScteType: AutoScteTime,
      // 计时为0关闭拿取scte的websocket
      CountDownScte: 5,
      // scte信息
      ScteMessage: {
        id: null,
        type: 4, // 类型
        autoTime: 120, // 时间
        IsBegin: true, // 是开始还是暂停
        time: 120,
        conmmandType: 1, // 信号源类型
        signalType: 16,
        scteType: 0
      },
      // scte开始计时或者倒计时
      ScteInterval: {
        function: null,
        time: 0
      },
      // scte历史列表
      ScteHistoryList: [],
      // 当前直播流的状态
      saveLoading: false,
      // 判断是splice类型还是time signal类型
      LocalSignalType: '',
      // PassthroughBlock开关
      PassthroughBlock: {
        switch: false,
        sctePassthroughBlockFeature: true,
        settingPassthroughBlock: false
      },
      // media,模板选择配置
      configParams: {},
      passthroughLoading: false,
      // LBand列表
      LBandList: [],
      ProgramId: '',
      // LBand信息
      LBandMessage: {
        LBandSwitch: false,
        LBandType: { title: 'L-Band', conmmandType: 99 }
      }
    }
  },
  computed: {
    ...mapState({
      pageSerBusRequest: state => state.websocket.pageSerBusRequest,
      CloneDisabled: (state) => state.playout.CloneDisabled,
      listFeatures: (state) => state.playout.listFeatures
    })
  },
  watch: {
    // 行为同步
    '$store.state.BehaviorChange' (data) {
      console.log('right-scte')
      if (data.action == 'SCTEListChange') {
        this.getScteList()
        this.SourceWebsocket()
      }
    },
    listFeatures: {
      handler (val) {
        if (val.includes('Scte UnderPlay')) {
          this.BreakUnderplay.scteUnderPlayFeature = true
        } else {
          this.BreakUnderplay.scteUnderPlayFeature = false
        }
        if (val.includes('sctePassthoughBlock')) {
          this.PassthroughBlock.sctePassthroughBlockFeature = true
        } else {
          this.PassthroughBlock.sctePassthroughBlockFeature = false
        }
        if (val.includes('L-Band')) {
          this.LBandMessage.LBandSwitch = true
        } else {
          this.LBandMessage.LBandSwitch = false
        }
      },
      immediate: true

    }
  },
  created () {
    this.ProgramId = this.$BehaviorSyns.getProgramId()
    this.init()
    this.getScteUnderplay() // 获取ScteUnderplay的信息
    this.getPassthroughBlock()
    this.getScteList() // 获取历史scte列表
    this.SourceWebsocket()
    this.SetconfigParams()

    console.log(this.ScteMessage)
  },
  mounted () {
    this.$on('ScteShortcut', () => {
      if (this.ScteMessage.IsBegin || this.ScteMessage.scteType == 2) {
        this.ScteCreateStart('开始')
      } else if (this.ScteMessage.scteType == 1) {
        this.ScteCreateStart('结束')
      }
    })
  },
  methods: {
    // 得到scte的行为记录
    async getScteBehavior () {
      const params = {
        pn: 'scte',
        remark: this.$BehaviorSyns.getProgramId(),
        serverName: 'channel'
      }
      let behavior = {}
      await this.axios.get('/ccp/tvucc-user/userBehavior/get', { params, requestBase: 'newCC' }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result && res.data.result[this.$BehaviorSyns.getProgramId()]) {
            behavior = JSON.parse(res.data.result[this.$BehaviorSyns.getProgramId()])
          } else {
            behavior = null
          }
        }
      }).catch((res) => {
        console.log(res)
        behavior = null
      })
      return behavior
    },
    // 设置scte需要记录的行为
    setScteBehavior () {
      const conmmandType = this.ScteMessage.conmmandType
      let scteParams
      if (!this.ScteMessage.scteType) {
        scteParams = {
          conmmandType: conmmandType,
          type: this.ScteMessage.type,
          time: this.ScteMessage.time,
          scteType: this.ScteMessage.scteType
        }
      } else if (this.ScteMessage.scteType == 1) {
        scteParams = {
          conmmandType: conmmandType,
          scteType: this.ScteMessage.scteType
        }
      } else {
        scteParams = {
          conmmandType: conmmandType,
          signalType: this.ScteMessage.signalType
        }
      }
      const params = {
        pn: 'scte',
        content: JSON.stringify(scteParams),
        remark: this.$BehaviorSyns.getProgramId(),
        serverName: 'channel'
      }
      this.axios.post('/ccp/tvucc-user/userBehavior/set', params, { requestBase: 'newCC' }).then(res => {}).catch(() => {})
    },
    // 设置media,模板选择配置
    SetconfigParams () {
      const ProgramMessage = Outil.getProgramReceiver()
      const bucketCode = ProgramMessage.bucketName
      const ownerUserId = ProgramMessage.ownerUserId
      const programId = ProgramMessage.ProgramId
      this.configParams = {
        List: {
          Media: {
            url: '/scteUnderplay/pageUnderPlay',
            Params: {
              pageNum: 0,
              pageSize: 10,
              totalNum: 1,
              bucketCode: bucketCode,
              userId: ownerUserId,
              type: 1
            },
            List: []
          },
          Live: {
            url: '/scteUnderplay/pageUnderPlay',
            Params: {
              pageNum: 0,
              pageSize: 10,
              totalNum: 1,
              condition: '',
              bucketCode: bucketCode,
              userId: ownerUserId,
              type: 3
            },
            List: []
          }
        },
        search: {
          url: '/scteUnderplay/pageUnderPlay',
          Params: {
            pageNum: 0,
            pageSize: 10,
            totalNum: 1,
            condition: '',
            bucketCode: bucketCode,
            userId: ownerUserId,
            type: 0
          }
        }
      }
    },
    // scte时间输入变化
    onTimeInput () {
      this.ScteMessage.time = this.ScteMessage.time.replace(/[^\d]/g, '')
      if (this.ScteMessage.time && this.ScteMessage.time.length > 5) {
        this.ScteMessage.time = 99999
      }
      this.setScteBehavior()
    },
    // 初始化
    async init () {
      const LocalSignalType = Outil.getProgramReceiver('scteType') || 0
      this.LocalSignalType = LocalSignalType
      // 获取scte行为信息
      const ScteBehavior = await this.getScteBehavior()
      if (LocalSignalType == 0) {
        this.signalType = [{ title: 'Splice insert', conmmandType: 1 }]
        // 判断是否有LBand权限
        if (this.LBandMessage.LBandSwitch) {
          this.signalType.push(this.LBandMessage.LBandType)
        }
        if (ScteBehavior && ScteBehavior.conmmandType == 1) {
          this.ScteMessage.conmmandType = ScteBehavior.conmmandType
          this.ScteMessage.type = ScteBehavior.type
          if (this.ScteMessage.type == 9) {
            this.ScteMessage.time = ScteBehavior.time
          }
        } else if (ScteBehavior && ScteBehavior.conmmandType == 99 && this.LBandMessage.LBandSwitch) {
          this.ScteMessage.conmmandType = ScteBehavior.conmmandType
          this.ScteMessage.signalType = ScteBehavior.signalType
          this.getLBandList()
        } else {
          this.ScteMessage.conmmandType = this.signalType[0].conmmandType
          this.ScteMessage.type = this.ScteType[5].type
        }
      } else {
        await this.getSignalList()
        // 判断行为记录中的值是否在列表中存在
        const isBehavior = this.signalType.some(v => v.conmmandType == (ScteBehavior && ScteBehavior.conmmandType))
        if (ScteBehavior && isBehavior) {
          if (ScteBehavior.scteType == 1) {
            this.ScteMessage.conmmandType = ScteBehavior.conmmandType
          } else if (!ScteBehavior.scteType) {
            this.ScteMessage.conmmandType = ScteBehavior.conmmandType
            this.ScteMessage.type = ScteBehavior.type
            if (this.ScteMessage.type == 9) {
              this.ScteMessage.time = ScteBehavior.time
            }
          } else if (ScteBehavior.scteType == 2) {
            this.ScteMessage.conmmandType = ScteBehavior.conmmandType
            this.ScteMessage.signalType = ScteBehavior.signalType
          } else {
            this.ScteMessage.conmmandType = this.signalType[0].conmmandType
          }
        } else {
          this.ScteMessage.conmmandType = this.signalType[0].conmmandType
        }
        const selectScte = this.signalType.filter(v => v.conmmandType == this.ScteMessage.conmmandType)
        this.ScteMessage.scteType = selectScte[0].type
      }
    },
    // 获取time signal列表
    async getSignalList () {
      await this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/scte'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            Object.keys(result.autoManuallyScte).forEach(key => {
              if (key.includes('auto') || key.includes('Auto')) {
                this.signalType.push({
                  title: key, conmmandType: result.autoManuallyScte[key], type: 0
                })
              } else {
                this.signalType.push({
                  title: key, conmmandType: result.autoManuallyScte[key], type: 1
                })
              }
            })
            this.signalType.push({ title: 'Time signal', conmmandType: 4, type: 2 })
            Object.keys(result.timeSignalScte).forEach(key => {
              this.conmmandTypeList.push({
                name: key, type: result.timeSignalScte[key]
              })
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // conmmandType设置为4时从本地拿到select列表
    getSignalType () {
      const signalType = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo.signalType
      const conmmandTypeList = signalType ? JSON.parse(signalType) : {}
      Object.keys(conmmandTypeList).forEach(key => {
        this.conmmandTypeList.push({
          name: key
        })
      })
    },
    // 选择scte类型
    changeConmmandType (type) {
      const selectScte = this.signalType.filter(v => v.conmmandType == type)
      this.ScteMessage.scteType = selectScte[0].type
      if (this.ScteMessage.scteType == 2) {
        this.ScteMessage.signalType = this.conmmandTypeList[0].type
      } else if (!this.ScteMessage.scteType) {
        this.ScteMessage.type = this.ScteType[5].type
      } else if (this.ScteMessage.conmmandType == 99) {
        this.getLBandList()
        this.ScteMessage.signalType = ''
      }
      this.setScteBehavior()
    },
    // scte的几种方式
    StartSettingScte (val) {
      this.ScteInterval.time = 0
      this.saveLoading = true
      const conmmandType = this.ScteMessage.conmmandType
      const scteType = this.ScteMessage.scteType
      let param
      const type = this.ScteMessage.type
      const SeleteScte = this.ScteType.filter(
        item => item.type == type
      )
      if (!scteType) {
        param = {
          title: SeleteScte[0].title,
          duration:
           this.ScteMessage.type == 9
             ? this.ScteMessage.time * 1000
             : SeleteScte[0].autoTime * 1000,
          startTime: new Date().getTime(),
          commandType: conmmandType,
          startFlag: true
        }
      } else if (scteType == 1) {
        const seleType = this.signalType.filter(item => item.conmmandType == conmmandType)
        if (val == '开始') {
          param = {
            title: seleType[0].title,
            startTime: new Date().getTime(),
            commandType: conmmandType,
            startFlag: true
          }
        } else {
          param = {
            title: seleType[0].title,
            endTime: new Date().getTime(),
            commandType: conmmandType,
            startFlag: false,
            scteId: this.ScteMessage.id
          }
        }
      } else {
        const salType = this.ScteMessage.signalType
        const selecConmmand = this.conmmandTypeList.filter(item => item.type == salType)
        param = {
          title: selecConmmand[0].name,
          startTime: new Date().getTime(),
          commandType: conmmandType,
          signalType: selecConmmand[0].type
        }
      }

      let url
      if (this.LocalSignalType == 0) {
        // scte类型为 splice时
        url = '/settingScte/addSettingScteEvent'
      } else {
        // scte类型为 time signal时
        url = '/settingScte/addTimeSignalSettingScteEvent'
      }
      this.axios({
        method: 'post',
        url: Outil.getUrl(url),
        data: param,
        timeout: 120000,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
        .then(res => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.ScteMessage.id = res.data.result.id
              if (!scteType) {
                this.ScteInterval.time = this.ScteMessage.type == 9 ? this.ScteMessage.time : SeleteScte[0].autoTime
              }
              this.getScteList()
              if (res.data.result.description == 'Stop ') {
                this.ScteMessage.IsBegin = true
              } else {
                this.ScteMessage.IsBegin = false
                this.SourceWebsocket()
              }
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
            this.saveLoading = false
          } else {
            this.saveLoading = false
          }
        })
        .catch(() => {
          this.saveLoading = false
        })
    },
    // PassthroughBlock信息
    getPassthroughBlock () {
      const param = {
        programId: this.$BehaviorSyns.getProgramId()
      }
      this.axios
        .post(Outil.getUrl('/program/getProgram'), param)
        .then(res => {
          if (res.data.errorCode == '0x0') {
            this.PassthroughBlock.settingPassthroughBlock = !!res.data.result.settingBlock
            this.PassthroughBlock.switch = !!res.data.result.playoutBlock
            if (this.PassthroughBlock.settingPassthroughBlock) {
              Bus.$emit('passthroughBlockOpen', this.PassthroughBlock.switch)
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {

        })
    },
    // PassthroughBlock开关变化
    BreakPassthroughBlock () {
      const param = {
        pid: this.$BehaviorSyns.getProgramId(),
        playoutBlock: this.PassthroughBlock.switch,
        rid: Outil.getProgramReceiver('rid')
      }
      this.passthroughLoading = true
      param.playoutBlock = this.PassthroughBlock.switch ? 1 : 0
      this.axios
        .post(Outil.getUrl('/program/switchPlayoutBlock'), param)
        .then(res => {
          this.passthroughLoading = false
          if (res.data.errorCode == '0x0') {
            Bus.$emit('passthroughBlockOpen', this.PassthroughBlock.switch)
          } else {
            this.PassthroughBlock.switch = !param.playoutBlock
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {
          this.passthroughLoading = false
          this.PassthroughBlock.switch = !param.playoutBlock
        })
    },
    // 开关变化
    BreakUnderplayChange () {
      if (this.BreakUnderplay.forbidden) {
        this.BreakUnderplay.switch = false
        this.$message({ type: 'error', message: this.$t('lang.selectAFile') })
      } else {
        this.addOrUpdateScteUnderplay()
      }
    },
    // 获取ScteUnderplay的信息
    getScteUnderplay () {
      this.axios
        .get(
          Outil.getUrl(
            `/scteUnderplay/getScteUnderplayByProgramId?programId=${this.$BehaviorSyns.getProgramId()}`
          )
        )
        .then(res => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result) {
              this.BreakUnderplayMessage = res.data.result
            } else {
              this.BreakUnderplayMessage = {}
            }
            if (res.data.result && res.data.result.fileId) {
              this.BreakUnderplay.forbidden = false
              this.BreakUnderplay.switch = !!res.data.result.turnOn
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {})
    },
    // 未播视频的scte的备用视频
    fileSeleteChange (pitchOnFile) {
      this.BreakUnderplayMessage.fileId = pitchOnFile.id
      this.BreakUnderplayMessage.fileName = pitchOnFile.name
      // this.BreakUnderplayMessage.url = pitchOnFile.url
      this.BreakUnderplayMessage.type = pitchOnFile.type
      this.BreakUnderplay.forbidden = false
      this.addOrUpdateScteUnderplay()
    },
    // 新增或修改ScteUnderplay
    addOrUpdateScteUnderplay () {
      this.scteLoading = true
      const param = this.BreakUnderplayMessage
      param.turnOn = this.BreakUnderplay.switch ? 1 : 0
      param.programId = this.$BehaviorSyns.getProgramId()
      this.axios
        .post(Outil.getUrl('/scteUnderplay/addOrUpdateScteUnderplay'), param, {
          timeout: 120000
        })
        .then(res => {
          if (res.data.errorCode == '0x0') {
            this.getScteUnderplay()
          } else {
            this.BreakUnderplay.switch = !param.turnOn
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.scteLoading = false
        })
        .catch(() => {
          this.getScteUnderplay()
          this.BreakUnderplay.switch = !param.turnOn
          this.scteLoading = false
        })
    },
    // 计算分秒小时
    calculateInterval (time) {
      if (typeof time == 'number') {
        let hour = Math.floor(time / (60 * 60 * 1000))
        let minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
        let second = Math.floor((time % (60 * 1000)) / 1000)
        hour = hour ? `${hour}h` : ''
        minute = minute ? `${minute}m` : ''
        second = second ? `${second}s` : ''
        return hour + minute + second
      } else {
        return ''
      }
    },
    // 展示时间
    displayTime (startTime) {
      const startDate = Outil.getDateTime(new Date(startTime))
      const startDay = `${startDate.year}-${startDate.month}-${startDate.day}`
      return `${startDay} ${startDate.hour}:${startDate.min}:${startDate.s}`
    },
    // 获取scte列表
    getScteList () {
      const startTime = new Date().getTime() - 24 * 60 * 60 * 1000
      const param = {
        startTime,
        pageNum: 1,
        pageSize: 1000
      }
      this.axios({
        method: 'post',
        url: Outil.getUrl('/settingScte/page'),
        data: param,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.ScteHistoryList = res.data.result.list
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 获取LBand列表
    getLBandList () {
      const param = {
        programId: this.ProgramId,
        pageNum: 1,
        pageSize: 1000
      }
      this.axios
        .post(Outil.getUrl('/L-Band/pageLBand'), param)
        .then(res => {
          if (res.data.errorCode == '0x0') {
            this.LBandList = res.data.result.list
            if (this.ScteMessage.signalType) {
              const LBandSome = this.LBandList.some((item) => {
                return item.id == this.ScteMessage.signalType
              })
              this.ScteMessage.signalType = LBandSome ? this.ScteMessage.signalType : ''
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {
        })
    },
    // scte的创建
    ScteCreateStart (val) {
      playoutAnalyze('playoutScteSettingsStart', '/pop')
      if (this.ScteMessage.conmmandType == 99) {
        this.StartEndLBand(val)
        return
      }
      this.StartSettingScte(val)
    },
    // 开始结束LBand
    StartEndLBand (type) {
      let url = '/L-Band/startLBand'
      if (type == '结束') {
        url = '/L-Band/endLBand'
      }
      this.saveLoading = true
      this.axios
        .post(Outil.getUrl(url), {
          id: this.ScteMessage.signalType,
          programId: this.ProgramId
        })
        .then(res => {
          if (res.data.errorCode == '0x0') {
            if (type == '结束') {
              this.ScteMessage.IsBegin = true
              this.getScteList()
              this.StopSourceWebsocket()
              this.CountDownScte = 5
            } else {
              this.ScteInterval.time = res.data.result
              this.ScteMessage.IsBegin = false
              this.getScteList()
              this.SourceWebsocket()
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.saveLoading = false
        })
        .catch(() => {
          this.saveLoading = false
        })
    },
    // websocket获取scte信息
    SourceWebsocket () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      const urlInfo = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
      const { websocketServerName } = urlInfo
      this.StopSourceWebsocket()
      this.pageSerBusRequest.send({
        message: {
          serverName: websocketServerName,
          data: JSON.stringify({
            data: JSON.stringify({
              receiverId: this.fixedDevice.peerId,
              programId: ProgramId
              // commandType: this.ScteMessage.conmmandType
            }),
            module: 'getRunningSettingScte'
          })
        },
        time: 500,
        key: 'getRunningSettingScte',
        success: res => {
          // res.result.data = null
          if (res.result.data) {
            this.CountDownScte = 5
            let item = res.result.data
            item = JSON.parse(item)
            if (item.status == 1) {
              this.ScteMessage.id = item.id
              this.ScteMessage.conmmandType = item.commandType
              this.ScteMessage.autoTime = item.duration
              this.ScteMessage.time =
                item.commandType == 9 ? item.duration : this.ScteMessage.time
              this.ScteMessage.IsBegin = false
              // const time = Math.ceil(
              //   (item.countDown) / 1000
              // )
              if (!this.ScteMessage.scteType) {
                this.ScteInterval.time = item.countDown
                const timeType = this.ScteType.filter((itm) => {
                  return item.duration == itm.autoTime
                })
                if (timeType[0]) {
                  this.ScteMessage.type = timeType[0].type
                } else {
                  this.ScteMessage.type = 9
                  this.ScteMessage.time = item.duration
                }
              } else if (this.ScteMessage.scteType == 1) {
                this.ScteInterval.time = item.countDown
              } else if (this.ScteMessage.conmmandType == 99) {
                this.ScteInterval.time = item.countDown
                this.ScteMessage.signalType = item.id
              }
            } else {
              this.ScteMessage.IsBegin = true
            }
          } else {
            this.CountDownScte--
            if (this.CountDownScte < 0) {
              this.ScteMessage.IsBegin = true
              this.StopSourceWebsocket()
              this.CountDownScte = 5
            }
          }
        }
      })
    },
    // 停止预览
    StopSourceWebsocket () {
      if (this.$createWebsocket.pageSerBusRequest) {
        this.$createWebsocket.pageSerBusRequest('stop', [
          'getRunningSettingScte'
        ]) // 停止websocket
      }
    }
  },
  beforeDestroy () {
    this.StopSourceWebsocket()
  }
}
</script>

<style lang="less" scoped>
.ScteContent {
  height: 430px;
  padding-right: 5px;
  overflow-y: scroll;
  .saveBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
   .PassthroughBlock{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #555555;
    padding: 10px 0px 9px;
    text-align: left;
    p {
      // width: 80px;
      margin: 0;
    }
    ::v-deep.SelectSwitch {
      margin-left: 20px;
      // width: 252px;
      // width: 70%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select {
        // width: 152px;
        .el-scrollbar__wrap {
          width: 180px;
        }
        .el-input__inner {
          background: #252525;
          height: 28px;
        }
      }
      .switchLoading {
        position: relative;
        .pushingIcon {
          display: inline-block;
          height: 20px;
          line-height: 20px;
          width: 40px;
          background: #33ab4f;
          border-radius: 10px;
          text-align: center;
          border: 1px solid #33ab4f;
          outline: none;
          vertical-align: middle;
          margin: 0 !important;
        }
      }
    }
  }
  .BreakUnderplay{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #555555;
    padding: 10px 0px 9px;
    text-align: left;
    p {
      width: 80px;
      margin: 0;
    }
    ::v-deep.SelectSwitch {
      // margin-left: 20px;
      // width: 252px;
      width: 79%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select {
        .el-scrollbar__wrap{
          max-width: 300px;
        }
        .el-input__inner {
          background: #252525;
          height: 28px;
          border-color: transparent ;
        }
      }
      .switchLoading {
        position: relative;
        .pushingIcon {
          display: inline-block;
          height: 20px;
          line-height: 20px;
          width: 40px;
          background: #33ab4f;
          border-radius: 10px;
          text-align: center;
          border: 1px solid #33ab4f;
          outline: none;
          vertical-align: middle;
          margin: 0 !important;
        }
      }
    }
  }
  ::v-deep.signalType {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    p {
      height: 17px;
      font-size: 14px;
      color: #dfdfdf;
      line-height: 17px;
      margin: 0;
    }
    .el-select {
      // width: 230px;
      width: 79%;
      .el-input__inner {
        border: none;
        background: #252525;
        height: 28px;
      }
    }
  }

  ::v-deep.ScteSelete {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    text-align: right;
    margin-top: 12px;
    p {
      height: 17px;
      font-size: 14px;
      color: #dfdfdf;
      line-height: 17px;
      margin: 0;
    }
    .el-select {
      width: 100%;
      .el-input__inner {
        border: none;
        background: #252525;
        height: 28px;
      }
    }
  }
  .autoSlider {
    position: relative;
    width: 252px;
    margin-left: auto;
    margin-bottom: 19px;
    margin-top: 15px;

    .el-slider__runway {
      margin-right: 90px;
      background: #585b5d;
      margin-top: 12px;

      .el-slider__marks {
        .el-slider__marks-text {
          margin-top: -25px;
          width: 43px;
        }

        .el-slider__marks-text:nth-child(1) {
          width: 30px;
        }
      }

      .el-slider__marks-stop {
        display: none;
      }
    }

    .el-slider__input {
      width: 79px;
      height: 28px;
      background: #313436;

      .el-input-number__decrease,
      .el-input-number__increase {
        display: none;
      }

      .el-input input {
        width: 65px;
        height: 28px;
        background: rgba(49, 52, 54, 1);
        border: 1px solid rgba(49, 52, 54, 1);
        color: #fff;
        text-align: left;
        padding-left: 4px;
        padding-right: 0px;
      }
    }

    .unit {
      position: absolute;
      right: 8px;
      top: 8px;
      font-size: 14px;
      color: #979da3;
    }
  }
  .signalSelect {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    .el-select {
      width: 252px;
      .el-input__inner {
        background: #252525;
        height: 28px;
      }
    }
    .el-select-dropdown__item {
      text-align: left;
      width: 252px;
    }
  }
  .ScteButton {
    margin-top: 12px;
    .CustomTime {
      position: relative;
      text-align: right;
      .el-input {
        margin-bottom: 20px;
        width: 280px;
      ::v-deep .el-input__inner {
          height: 29px;
          border: none;
          padding-right: 70px;
        }
      }
      span {
        position: absolute;
        right: 10px;
        top: 3px;
      }
    }
    .button {
      width: 100%;
      height: 32px;
      border-radius: 2px;
      text-align: center;

    }
    .ScteStart {
      background: #33ab4f;
      line-height:32px;
    }
    .ScteStop {
      background: #ec5050;
      line-height:0;
    }
    .autoScteStop{
      background: #ec5050;
      line-height:32px;
    }
  }
  .ScteHistoryList {
    margin-top: 11px;
    padding-top: 15px;
    border-top: 2px solid #555555;
    .ScteHistory {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      .left {
        text-align: left;
        .name {
          color: #dfdfdf;
        }
        .time {
          color: #888888;
          margin-top: 3px;
        }
      }
      .right {
        color: #dbdbdb;
        span {
          color: #888888;
        }
      }
    }
  }
}
</style>
